Jelly.Actions.Validate_Member = function(Parameters) { 

	// Validate input
	var Email_Validator = new RegExp('^\[^@\\s\]+@\[^@\\s\]+\\.\[^@\\s\]+$', 'i');
	if (!Parameters.Name) { 
		return'Please enter a name';
	}
	if (!Email_Validator.test(Parameters.Email)) {
		return 'Please enter a valid email address';
	}

	// Make sure that member doesn't already exist in table
	var Email_Is_Unique = true;
	var $Add_Member_Table_Wrapper = $(
		"#" + Parameters.Namespace.Action + "_" + Parameters.Namespace.Membership + "_Add_Member_Table_Wrapper"
	);
	$Add_Member_Table_Wrapper.find('table tr').each(function(Row_Index, Row) {
		if (Parameters.Email == $(Row).find('td:eq(1)').html()) {
			return (Email_Is_Unique = false);
		}
	});
	if (!Email_Is_Unique)
		return "You've already entered this email address";
};